import React, { useEffect, useState } from 'react';
import MasterLayout from '../../layouts/MasterLayout';
import ThemeBreadcrumb from '../../components/themes/ThemeBreadcrumb';
import HomeModel from '../../models/HomeModel';
import AppNotification from '../../helpers/AppNotification';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Paginate from '../../components/paginate/Paginate';
import UserModel from '../../models/UserModel';
import ComboModel from '../../models/ComboModel';
import ModalDepositHandmade from '../../components/paymentdeposit/ModalDepositHandmade';
import ModalDetailUser from '../../components/users/ModalDetailUser';
import HomeAdminCardMoney from '../../components/homeAdmin/HomeAdminCardMoney';
import Swal from "sweetalert2";
import ModalAcountApp from '../../components/homeAdmin/ModalAcountApp';
import { Link } from 'react-router-dom';
import ModalRegister from '../../components/account/ModalRegister';
import ModalAdminComboOrders from '../../components/admin/ModalAdminComboOrders';


function AdminHomePage(props) {

    // show modal account app
    const [showAcountApp,setShowAcountApp] = useState(false);
    const [showModalRegister,setShowModalRegister] = useState(false);
    const [showComboOrdersModal, setShowComboOrdersModal] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [userID,setUserID] = useState('');
    const [flagUserID,setFlagUserID] = useState(false);
    useEffect(() => {
        if (flagUserID == true) {
            setShowAcountApp(true);
        }
    }, [userID,flagUserID])
    const handleShowModalAppAcount = (id) => {
        setOpenDropdownId(null);
        setUserID(id);
        setFlagUserID(true);
    }

    const handleShowModalRegister = () => {
        setShowModalRegister(true);
    }

    const handleCloseModalRegister = () => {
        setShowModalRegister(false);
    }

    const handleCloseModalAcountApp = () => {
        setUserID('');
        setShowAcountApp(false);
        setFlagUserID(false);
    }

    // xử lí tổng quan
    const [total, setTotal] = useState({});

    useEffect(() => {
        HomeModel.getDashboardAdmin().then((res) => {
            setTotal(res.data);
        }).catch((err) => {
            AppNotification.showError('Lấy dữ liệu thất bại!');
        })
    }, [])

    // paginate
    const [perPage, setPerPage] = useState(25);
    const [page, setPage] = useState(1);
    const [meta, setMeta] = useState({});
    const changePage = (page) => {
        setPage(page);
        setFilter({ search: keyword });
    }
    const handleSetPage = (number) => {
        setPage(page + number);
        setFilter({ search: keyword });
    }

    // search
    const [keyword, setKeyword] = useState({
        user_name : null
    });
    const [filter, setFilter] = useState({
        search: '',
        perPage: perPage,
        page: page,
    });
    const handleChange = (event) => {
        setKeyword({
            ...keyword,
            [event.target.name]: event.target.value
        });
        setPage(1);
        // Xử lý tìm kiếm dữ liệu dựa trên keyword
        setFilter({ search: keyword });
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        setPage(1);
        // Xử lý tìm kiếm dữ liệu dựa trên keyword
        setFilter({ search: keyword });
        // Reset trường input sau khi submit
    }


    // xử lý
    const [data, setData] = useState([]);


    useEffect(() => {
        UserModel.getAllUser(
            {
                search: filter.search,
                page: page,
                perPage: perPage
            }
        ).then((res) => {
            setData(res.data);
            setMeta(res.meta);
        }).catch((err) => {
            console.log(err);
            AppNotification.showError('Lấy dữ liệu thất bại!');
        })
    }, [page, filter])

    const handleChangeperPage = (e) => {
        setPerPage(e.target.value);
        setPage(1);
        setFilter({ search: keyword });
    }

    // show modal napj tiền thủ công
    const [modalShowTransfer, setModalShowTransfer] = React.useState(false);
    const handleCloseModalTransfer = () => {
        setModalShowTransfer(false);
    };
    const [flag, setFlag] = useState(false);
    const [dataRecord, setDataRecord] = useState({
        user_id: '',
        name: '',
    });

    useEffect(() => {
        if (flag == true) {
            setModalShowTransfer(true);
        }
    }, [dataRecord, flag])

    const handleShowModalTransfer = (user_id, name) => {
        setOpenDropdownId(null);
        setDataRecord({
            user_id: user_id,
            name: name,
        });
        setFlag(true);

    };

    // xử lí showModal cấp quyền 
    const [modalShow, setModalShow] = React.useState(false);
    const [flagRole, setFlagRole] = useState(false);
    const [user, setUser] = useState({});
    useEffect(() => {
        if (flagRole === true) {
            setModalShow(true);
        }
    }, [user, flagRole])

    
    const handleQuickAddVip = (item) => {
        setOpenDropdownId(null);
        const currentDays = item.combo_days !== undefined && item.combo_days !== null && Number(item.combo_days) > 0
            ? Number(item.combo_days)
            : ((Number(item.combo_slots || 0)) * 30);
        const currentSlots = Math.floor(currentDays / 30);

        Swal.fire({
            title: 'Cộng Lượt / Ngày VIP Cho User',
            html: `
                <div style="text-align: left; font-size: 13.5px; color: #cbd5e1; line-height: 1.6;">
                    <div style="background: rgba(255,255,255,0.05); padding: 10px 14px; border-radius: 8px; margin-bottom: 14px; border: 1px solid rgba(255,255,255,0.1);">
                        <div>Tài khoản User: <b style="color: #38bdf8;">${item.user_name}</b> (${item.name || ''})</div>
                        <div>Hiện có: <b style="color: #f59e0b;">${currentSlots} lượt</b> (<b style="color: #10b981;">${currentDays} ngày VIP</b>)</div>
                    </div>

                    <label style="display: block; font-weight: 600; margin-bottom: 6px; color: #f8fafc;">1. Chọn nhanh số Lượt hoặc Ngày muốn cộng:</label>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 12px;">
                        <button type="button" class="swal-quick-btn" data-type="slots" data-val="1" style="padding: 8px; background: #1e293b; border: 1px solid #f59e0b; color: #fbbf24; border-radius: 6px; font-weight: 600; cursor: pointer;">+1 Lượt (30 ngày)</button>
                        <button type="button" class="swal-quick-btn" data-type="slots" data-val="5" style="padding: 8px; background: #1e293b; border: 1px solid #f59e0b; color: #fbbf24; border-radius: 6px; font-weight: 600; cursor: pointer;">+5 Lượt (150 ngày)</button>
                        <button type="button" class="swal-quick-btn" data-type="days" data-val="1" style="padding: 8px; background: #1e293b; border: 1px solid #38bdf8; color: #38bdf8; border-radius: 6px; cursor: pointer;">+1 Ngày lẻ</button>
                        <button type="button" class="swal-quick-btn" data-type="days" data-val="7" style="padding: 8px; background: #1e293b; border: 1px solid #38bdf8; color: #38bdf8; border-radius: 6px; cursor: pointer;">+7 Ngày lẻ</button>
                    </div>

                    <label style="display: block; font-weight: 600; margin-bottom: 4px; color: #f8fafc;">2. Hoặc nhập số lượng tùy ý:</label>
                    <div style="display: flex; gap: 8px;">
                        <input type="number" id="swal_custom_vip_val" min="1" placeholder="Nhập số..." style="flex: 1; padding: 8px 10px; background: #0f172a; border: 1px solid #334155; border-radius: 6px; color: #fff;" />
                        <select id="swal_custom_vip_type" style="padding: 8px 10px; background: #0f172a; border: 1px solid #334155; border-radius: 6px; color: #fff;">
                            <option value="slots">Lượt (= 30 ngày)</option>
                            <option value="days">Ngày VIP lẻ</option>
                        </select>
                    </div>
                </div>
            `,
            background: '#111827',
            color: '#f8fafc',
            showCancelButton: true,
            confirmButtonText: 'Xác Nhận Cộng',
            cancelButtonText: 'Đóng',
            confirmButtonColor: '#f59e0b',
            cancelButtonColor: '#475569',
            didOpen: () => {
                const buttons = document.querySelectorAll('.swal-quick-btn');
                const customInput = document.getElementById('swal_custom_vip_val');
                const customType = document.getElementById('swal_custom_vip_type');

                buttons.forEach(btn => {
                    btn.addEventListener('click', () => {
                        const type = btn.getAttribute('data-type');
                        const val = btn.getAttribute('data-val');
                        customType.value = type;
                        customInput.value = val;
                        buttons.forEach(b => {
                            b.style.opacity = '0.5';
                        });
                        btn.style.opacity = '1';
                    });
                });
            },
            preConfirm: () => {
                const val = parseInt(document.getElementById('swal_custom_vip_val').value, 10);
                const type = document.getElementById('swal_custom_vip_type').value;
                if (!val || val <= 0) {
                    Swal.showValidationMessage('Vui lòng chọn hoặc nhập số lượng muốn cộng!');
                    return false;
                }
                return { type, val };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                Swal.fire({
                    title: 'Đang xử lý...',
                    allowOutsideClick: false,
                    background: '#111827',
                    color: '#fff',
                    didOpen: () => Swal.showLoading()
                });

                const payload = { user_id: item.id };
                if (result.value.type === 'slots') {
                    payload.slots = result.value.val;
                } else {
                    payload.days = result.value.val;
                }

                ComboModel.adminAddUserSlots(payload).then(res => {
                    if (res.success || res.status) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Thành công!',
                            text: res.message || 'Đã cộng lượt/ngày VIP thành công!',
                            background: '#111827',
                            color: '#fff',
                            confirmButtonColor: '#10b981'
                        });
                        // Reload data
                        UserModel.getAllUser({
                            search: filter.search,
                            page: page,
                            perPage: perPage
                        }).then(r => {
                            setData(r.data);
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Thất bại!',
                            text: res.message || 'Không thể cộng lượt',
                            background: '#111827',
                            color: '#fff'
                        });
                    }
                }).catch(err => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Lỗi!',
                        text: err?.response?.data?.message || err?.message || 'Có lỗi xảy ra',
                        background: '#111827',
                        color: '#fff'
                    });
                });
            }
        });
    };

    const handleShowModalRole = (item) => {
        setOpenDropdownId(null);
        setUser(item);
        setFlagRole(true);

    };

    const handleCloseModalRole = () => {
        setUser({});
        setFlagRole(false);
        setModalShow(false);
    }

    const reloadPage = () => {
        window.location.reload();
    };


    const handleShowModalAppHistory = (id) => {
        UserModel.updateAppHistory(id)
            .then(res => {
                Swal.fire({
                    icon: "success",
                    title: "Cập nhật thành công!",
                    showConfirmButton: false,
                    timer: 2000,
                });
                setFilter({ search: keyword });
            }).catch(err => {   
                Swal.fire({
                    icon: "error",
                    title: "Cập nhật thất bại!",
                    showConfirmButton: false,
                    timer: 2000,
                });
            })
    }

    // xóa user
    const handleDelete = (id) => {
        setOpenDropdownId(null);
        const shouldDelete = window.confirm('Bạn có chắc chắn muốn xóa không?');
        if (shouldDelete) {
            UserModel.delete(id)
                .then(res => {
                    Swal.fire({
                        icon: "success",
                        title: "Xóa thành công!",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    reloadPage();
                }).catch(err => {
                    Swal.fire({
                        icon: "error",
                        title: "Xóa thất bại!",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    console.log(err);
                    AppNotification.showError('Xóa thất bại!');
                })
        }
    }

    // update Status
    const handleUpdateStatus = (user_id, status) => {
        setOpenDropdownId(null);
        UserModel.updateStatus({
            user_id: user_id,
            status: status,
        })
            .then(res => {
                Swal.fire({
                    icon: "success",
                    title: "Cập nhật thành công!",
                    showConfirmButton: false,
                    timer: 2000,
                });
                setTimeout(() => {
                    reloadPage();
                }, 2000);
            }).catch(err => {
                Swal.fire({
                    icon: "error",
                    title: "Cập nhật thất bại!",
                    showConfirmButton: false,
                    timer: 5000,
                });
                console.log(err);
                AppNotification.showError('Cập nhật thất bại!');
            })
    }


    return (
        <MasterLayout>
            <ThemeBreadcrumb title="Danh sách account" />
            <div className='row'>
                <div className='col-xl-12'>
                    <div className='row'>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng người dùng :'} value={total.total_user} />
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Người dùng hoạt động :'} value={total.total_user_active} />
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Người dùng vô hiệu hóa:'} value={total.total_user_NoActive} />
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Đăng ký hôm nay :'} value={total.usersToday} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-12">
                    <div className="card">
                        <div className="card-header d-flex flex-row justify-content-between align-items-center flex-wrap gap-2">
                            <h4 className="card-title mb-0">Danh sách account</h4>
                            <div className="d-flex flex-wrap gap-2">
                                <Link to="/admin/transactions" className="btn btn-secondary">
                                    Thống kê Tạo & Gia hạn
                                </Link>
                                <button className="btn btn-warning text-dark font-weight-bold" onClick={() => setShowComboOrdersModal(true)}>
                                    Quản lý Đơn Combo VIP
                                </button>
                                <button className="btn btn-primary" onClick={handleShowModalRegister}>+ Thêm tài khoản</button>
                            </div>
                        </div>
                        <div className="card-body">
                            <style>{`
                                .admin-action-dropdown {
                                    position: relative !important;
                                    display: inline-block !important;
                                }
                                .admin-action-toggle.btn {
                                    height: 32px !important;
                                    font-weight: 600 !important;
                                    padding: 0 11px !important;
                                    border-radius: 7px !important;
                                    display: inline-flex !important;
                                    align-items: center !important;
                                    justify-content: center !important;
                                    gap: 5px !important;
                                    font-size: 12.5px !important;
                                    white-space: nowrap !important;
                                }
                                .admin-action-menu.dropdown-menu,
                                .admin-action-menu.dropdown-menu.show {
                                    position: absolute !important;
                                    inset: calc(100% + 4px) auto auto 0px !important;
                                    top: calc(100% + 4px) !important;
                                    left: 0px !important;
                                    right: auto !important;
                                    bottom: auto !important;
                                    transform: none !important;
                                    animation: none !important;
                                    margin: 0 !important;
                                    z-index: 1020 !important;
                                    background: var(--wus-dropdown-bg) !important;
                                    border: 1px solid var(--wus-border-strong) !important;
                                    border-radius: 10px !important;
                                    box-shadow: var(--wus-shadow-lg) !important;
                                    padding: 6px !important;
                                    min-width: 205px !important;
                                }
                                .admin-action-item.dropdown-item {
                                    padding: 8px 12px !important;
                                    font-size: 13px !important;
                                    font-weight: 500 !important;
                                    border-radius: 7px !important;
                                    display: flex !important;
                                    align-items: center !important;
                                    transition: background-color 0.12s ease !important;
                                }
                            `}</style>
                            <div className='table-responsive' style={{ minHeight: '380px', paddingBottom: '220px' }}>
                                <div id="example3_wrapper" className="dataTables_wrapper no-footer">
                                    <div className='row mb-3'>
                                        <div className='col-md-3 d-flex align-items-end'>
                                            <div className="dataTables_length text-dark" id="example3_length">
                                                <label>
                                                    Hiển thị{" "}
                                                    <select
                                                        name="example3_length"
                                                        aria-controls="example3"
                                                        className=""
                                                        value={perPage}
                                                        onChange={(e) => handleChangeperPage(e)}
                                                    >
                                                        <option value={1}>1</option>
                                                        <option value={25}>25</option>
                                                        <option value={100}>100</option>
                                                    </select>{" "}
                                                    dữ liệu.
                                                </label>
                                            </div>
                                        </div>
                                        <div className='col-md-9 col-12 d-flex justify-content-end'>
                                            <form className='w-100' onSubmit={handleSubmit}>
                                                <div className='row'>
                                                        <div className='col-md-2 offset-md-4 col-12 mb-2'>
                                                            <label className=''>Tìm kiếm : </label>
                                                            <input
                                                                type='text'
                                                                className='form-control'
                                                                placeholder='Tên, email, số tài khoản'
                                                                name='user_name'
                                                                value={keyword.search_text}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-2 col-12 mb-2'>
                                                            <label className=''>Từ ngày : </label>
                                                            <input
                                                                type='date'
                                                                name='start_date'
                                                                className='form-control'
                                                                value={keyword.start_date}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-2 col-12 mb-2'>
                                                            <label className='ms-2'>Đến ngày : </label>
                                                            <input
                                                                type='date'
                                                                name='end_date'
                                                                className='form-control'
                                                                value={keyword.end_date}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <div
                                                            className='col-md-2 col-12 d-flex flex-column justify-content-end mb-2'>
                                                            <div className='input-group-append'>
                                                                <button className='btn light btn-light ms-2'
                                                                        type='submit'>
                                                                    Tìm kiếm
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </form>
                                        </div>
                                    </div>
                                    <table
                                        id="example3"
                                        className="display dataTable no-footer"
                                        style={{ width: '100%' }}
                                        role="grid"
                                        aria-describedby="example3_info"
                                    >
                                        <thead>
                                            <tr role="row">
                                                <th
                                                    className="sorting_asc"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-sort="ascending"
                                                    aria-label=": activate to sort column descending"
                                                    style={{ width: "115px" }}
                                                >
                                                    THAO TÁC
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Name: activate to sort column ascending"
                                                    style={{ width: "172.5px" }}
                                                >
                                                    ID
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Name: activate to sort column ascending"
                                                    style={{ width: "172.5px" }}
                                                >
                                                    NGƯỜI DÙNG
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Department: activate to sort column ascending"
                                                    style={{ width: "205.312px" }}
                                                >
                                                    TÊN TÀI KHOẢN
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Gender: activate to sort column ascending"
                                                    style={{ width: "90.7031px" }}
                                                >
                                                    SỐ DƯ
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Education: activate to sort column ascending"
                                                    style={{ width: "156.734px" }}
                                                >
                                                    TỔNG NẠP
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Mobile: activate to sort column ascending"
                                                    style={{ width: "130.516px" }}
                                                >
                                                    TÌNH TRẠNG
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Mobile: activate to sort column ascending"
                                                    style={{ width: "130.516px" }}
                                                >
                                                    TRẠNG THÁI
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Email: activate to sort column ascending"
                                                    style={{ width: "150.891px" }}
                                                >
                                                    NGÀY TẠO
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Email: activate to sort column ascending"
                                                >
                                                    LỊCH SỬ <br /> GIAO DỊCH
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data.map((item, key) => (
                                                    <tr key={key} role="row" className="odd">
                                                        <td>
                                                            {
                                                                item.role === 1 ? 
                                                                    <div className="d-flex">
                                                                        <Dropdown
                                                                            className="admin-action-dropdown"
                                                                            show={openDropdownId === item.id}
                                                                            onToggle={(isOpen) => setOpenDropdownId(isOpen ? item.id : null)}
                                                                            autoClose={true}
                                                                        >
                                                                            <Dropdown.Toggle variant="primary" className="admin-action-toggle" id={`dropdown-action-${item.id}`}>
                                                                                Thao tác
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu className="admin-action-menu">
                                                                                <Dropdown.Item onClick={() => handleShowModalTransfer(item.id, item.name)} className="admin-action-item">
                                                                                    Nạp tiền thủ công
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item onClick={() => handleQuickAddVip(item)} className="admin-action-item" style={{ color: '#fbbf24', fontWeight: 600 }}>
                                                                                    + Gán Lượt/Ngày VIP
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item onClick={() => handleShowModalRole(item)} className="admin-action-item">
                                                                                    Chỉnh sửa
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item onClick={() => handleShowModalAppAcount(item.id)} className="admin-action-item">
                                                                                    Tài khoản App
                                                                                </Dropdown.Item>
                                                                                {
                                                                                    item.status == 1 ?
                                                                                        <Dropdown.Item onClick={(e) => handleUpdateStatus(item.id, 0)} className="admin-action-item">
                                                                                            Vô hiệu hóa
                                                                                        </Dropdown.Item>
                                                                                        :
                                                                                        <Dropdown.Item onClick={(e) => handleUpdateStatus(item.id, 1)} className="admin-action-item">
                                                                                            Kích hoạt
                                                                                        </Dropdown.Item>
                                                                                }
                                                                                <Dropdown.Divider style={{ margin: '4px 0', opacity: 0.15 }} />
                                                                                <Dropdown.Item onClick={(e) => handleDelete(item.id)} className="admin-action-item" style={{ color: '#f87171' }}>
                                                                                    Xóa tài khoản
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </div>
                                                                : 
                                                                <div className="d-flex">
                                                                    <span className="badge badge-success">Admin</span>
                                                                </div>
                                                            }
                                                        </td>
                                                        <td>
                                                            <div className="d-flex text-warning">
                                                                {item.id}
                                                            </div>
                                                        </td>
                                                        <td className='text-warning'>
                                                            <div className='row'>
                                                                <div className='col-12'>
                                                                    <span className='text-primary'>{item.name}</span> <br />
                                                                    <span>{item.email}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className='text-warning'>{item.user_name}</td>
                                                        <td className='text-warning'>{item.account_balance_fm} đ</td>
                                                        <td className='text-warning'>{item.total_deposit} đ</td>
                                                        {
                                                            item.isOnline === true ?
                                                                <td><span className="badge badge-success">online</span></td>
                                                                :
                                                                <td><span className="badge badge-danger">offline</span></td>
                                                        }
                                                        {
                                                            item.status == 1 ?
                                                                <td ><span className="badge light badge-success">Đã kích hoạt</span>
                                                                </td>
                                                                :
                                                                <td><span className="badge light badge-danger">Vô hiệu hóa</span>
                                                                </td>
                                                        }
                                                        <td className='text-warning'>{item.create_at_fm}</td>
                                                        <td>
                                                            <button type='button' className={`badge ${item.can_view_app_history ? 'badge-success' : 'badge-danger'}`} onClick={() => handleShowModalAppHistory(item.id)}>{item.can_view_app_history ? 'Được xem' : 'Không được xem'}</button>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    <Paginate meta={meta} changePage={changePage} page={page} handleSetPage={handleSetPage} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalDepositHandmade
                show={modalShowTransfer}
                onHide={handleCloseModalTransfer}
                dataRecord={dataRecord}
                reloadPage={reloadPage}
            />
            <ModalDetailUser
                show={modalShow}
                onHide={handleCloseModalRole}
                user={user}
                reloadPage={reloadPage}
            />
            <ModalAcountApp
                show={showAcountApp}
                onHide={handleCloseModalAcountApp}
                userID={userID}
            />
            <ModalRegister
                show={showModalRegister}
                onHide={handleCloseModalRegister}
            />
            <ModalAdminComboOrders
                show={showComboOrdersModal}
                onHide={() => setShowComboOrdersModal(false)}
                onUpdated={() => reloadPage()}
            />
        </MasterLayout>
    );
}

export default AdminHomePage;